
    import Mirador from '../../../src';
    import config from './mirador-configs/index.js';
    Mirador.viewer(config);
    // TODO Check
  